import { estEchecGeneration, LIBELLE_CAUSE_ECHEC, type RaisonMouvement } from '../../lib/labels';

/**
 * Raison d'une génération échouée, sous le libellé « Remboursement » du
 * journal des crédits : la cause en clair, puis l'erreur du fournisseur.
 */
export function RaisonEchec({
  m,
}: {
  m: { reason: RaisonMouvement; refType?: string | null; detail?: string | null; failureCause?: string | null };
}) {
  if (!estEchecGeneration(m)) return null;
  if (!m.detail) return <div className="cell-sub">Raison non enregistrée : échec antérieur au suivi des causes</div>;
  return (
    <div className="echec">
      <span className="echec__cause">{LIBELLE_CAUSE_ECHEC[m.failureCause ?? 'autre'] ?? LIBELLE_CAUSE_ECHEC.autre}</span>
      <span className="echec__detail" title={m.detail}>
        {m.detail}
      </span>
    </div>
  );
}
